export const ERROR = "ERROR"
export const SAVE_WORK = "SAVE_WORK"